import createUrlBuilder from 'utilities/url.builder.utils';
import { getRequest, patchRequest, postRequest } from 'utilities/service.utils';
import AppService from './app.service.context';
import { NewMember } from 'redux/member/types';
import { FetchOrgProfileParams, UpdateOrgProfileParams } from 'types';

/*
 * Params:
 *       role = ASSETOWNER
 *       orderBy = name
 *       include = PrimaryContact
 */
export const fetchAllMember = async ({ params }: any) => {
  const urlBuilder = createUrlBuilder(`/community/organisations`);
  return await getRequest(AppService, urlBuilder.toString(), params);
};

export const fetchMemberByName = async (
  name: string,
  role: string = 'ASSETOWNER',
  orderBy: string = 'name',
  offset: number = 0
) => {
  const urlBuilder = createUrlBuilder(
    `/community/organisations?fields=*&include=PrimaryContact&order=${orderBy}&filter=role:${role}&filter=name:%25${name}%25&offset=${offset}`
  );
  const result = await getRequest(AppService, urlBuilder.toString());
  return result;
};

export const addNewMember = async (data: NewMember) => {
  const urlBuilder = await createUrlBuilder('/community/organisations');
  return await postRequest(AppService, urlBuilder.toString(), data);
};

export const getOrganisationType = async () => {
  const urlBuilder = await createUrlBuilder('/system/domains/ORG_TYPE');
  return await getRequest(AppService, urlBuilder.toString());
};
export const fetchOrganisationProfile = async (
  request: FetchOrgProfileParams
) => {
  const { organisationId, params } = request;
  const urlBuilder = await createUrlBuilder(
    `/community/organisations/${organisationId}`
  );
  const response = await getRequest(AppService, urlBuilder.toString(), params);
  return response;
};

export const fetchOrganisationTenants = async () => {
  const urlBuilder = await createUrlBuilder(`/community/tenants`);
  const response = await getRequest(AppService, urlBuilder.toString());
  return response;
};

export const updateOrganisationProfile = async (
  request: UpdateOrgProfileParams
) => {
  const { organisationId, payload } = request;
  const urlBuilder = createUrlBuilder(
    `/community/organisations/${organisationId}`
  );

  const response = await patchRequest(
    AppService,
    urlBuilder.toString(),
    payload
  );

  return response;
};
/*
 * GET ORGANISATION LIST:: BY LOCATION BOUNDARY
 * param: shape {type,coordinates}
 */
export const fetchOrgListByBoundaryService = async (
  shape: any,
  limit?: any
) => {
  const urlBuilder = createUrlBuilder('/community/organisations');
  urlBuilder.addParameter('limit', limit);
  urlBuilder.addParameter('fields', '*');
  urlBuilder.addParameter('forWOBO', true);
  urlBuilder.addParameter('extent', JSON.stringify(shape));
  const result = await getRequest(AppService, urlBuilder.toString());
  return result;
};
